import EventCarousel from './eventCarousel/eventCarousel.component';
import CategoryDetails from './categoryDetails/categoryDetails.component';
export { EventCarousel, CategoryDetails };
